<template>
    <div>
        <DCard
            padding
        >
            <DForm @submit.prevent>
                <div class="code-textarea-container">
                    <DRow>
                        <DCol col="7">
                            <DFormRow
                                class="mb-4"
                                is-vertical
                                :label="__('tools.emails.footer_links.language')"
                                is-required
                                :error="validationErrors['language_code']"
                            >
                                <DInput
                                    :value="link.language.text"
                                    disabled
                                />
                            </DFormRow>
                            <DFormRow
                                :label="__('tools.emails.footer_links.informal_editor')"
                                is-vertical
                                is-required
                                :error="validationErrors['template.informal_content']"
                            >
                                <DFormTextarea
                                    id="informal_content"
                                    v-model="form.informal_content"
                                    rows="15"
                                />
                            </DFormRow>
                            <PreviewText
                                is-html
                                :email-type="emailType"
                                :content="form.informal_content"
                            />
                            <DFormRow
                                :label="__('tools.emails.footer_links.informal_plain_text_editor')"
                                is-vertical
                                is-required
                                :error="validationErrors['template.informal_plain_text_content']"
                            >
                                <DFormTextarea
                                    id="informal_plain_text_content"
                                    v-model="form.informal_plain_text_content"
                                    rows="10"
                                />
                            </DFormRow>
                            <PreviewText
                                :content="form.informal_plain_text_content"
                                :email-type="emailType"
                            />
                            <DFormRow
                                :label="__('tools.emails.footer_links.formal_editor')"
                                is-vertical
                                is-required
                                :error="validationErrors['template.formal_content']"
                            >
                                <DFormTextarea
                                    id="formal_content"
                                    v-model="form.formal_content"
                                    rows="15"
                                />
                            </DFormRow>
                            <PreviewText
                                is-html
                                :content="form.formal_content"
                                :email-type="emailType"
                            />
                            <DFormRow
                                :label="__('tools.emails.footer_links.formal_plain_text_editor')"
                                is-vertical
                                is-required
                                :error="validationErrors['template.formal_plain_text_editor']"
                            >
                                <DFormTextarea
                                    id="formal_plain_text_content"
                                    v-model="form.formal_plain_text_content"
                                    rows="10"
                                />
                            </DFormRow>
                            <PreviewText
                                :content="form.legal_info"
                                :email-type="emailType"
                            />
                        </DCol>
                        <DCol col="5">
                            <h2 class="h5">
                                {{ __('tools.emails.footer_legal_info.legend') }}
                            </h2>
                            <EmailPlaceholders :placeholders="placeholders" />
                        </DCol>
                    </DRow>
                </div>
            </DForm>
            <EmailEditPreviewModal
                :show-modal="showPreviewModal"
                :brands="brands"
                :mailables="mailables"
                :form="form"
                :preview-route="previewRoute"
                :content-update-route="contentUpdateRoute"
                @closeModal="showPreviewModal=false"
                @modalError="handleModalError"
            />
            <DFabs>
                <DFab
                    id="btn-save"
                    icon="eye"
                    :label="__('messages.preview')"
                    @click="handlePreview"
                />
            </DFabs>
        </DCard>
    </div>
</template>

<script>

import PreviewText from '~@/Components/Tools/Emails/PreviewText'
import EmailPlaceholders from '~@/Components/Tools/Emails/Placeholders'
import EmailEditPreviewModal from '~@/Components/Tools/Emails/EmailEditPreviewModal'

export default {
    name: 'LinksEdit',
    components: { EmailEditPreviewModal, EmailPlaceholders, PreviewText },
    props: {
        link: {
            type: Object,
            default: () => { return {} }
        },
        brands: {
            type: Object,
            default: () => { return {} }
        },
        placeholders: {
            type: Object,
            default: () => { return {} }
        },
        errors: {
            type: Object,
            default: () => { return {} }
        },
        mailables: {
            type: Array,
            default: () => { return [] }
        }
    },
    data () {
        return {
            saveDisabled: true,
            emailType: 'links',
            showPreviewModal: false,
            previewRoute: this.$route('tools.emails.footer-links-preview'),
            contentUpdateRoute: this.$route('tools.emails.footer-links-update'),
            validationErrors: this.errors,
            form: this.$inertia.form({
                formal_content: this.link.formalContent,
                informal_content: this.link.informalContent,
                formal_plain_text_content: this.link.formalPlainTextContent,
                informal_plain_text_content: this.link.informalPlainTextContent,
                language_code: this.link.language.value
            })
        }
    },
    methods: {
        handlePreview () {
            this.showPreviewModal = true
        },
        handleModalError (errorObject) {
            Object.keys(errorObject).forEach((field) => {
                errorObject[field].forEach((message) => {
                    this.validationErrors[field] = message
                })
            })
        }
    }
}
</script>
